/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Create_FailedInputs */

const en_team_create_failed = /** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create team.`)
};

const es_team_create_failed = /** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al crear el equipo.`)
};

const fr_team_create_failed = /** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la création de l'équipe.`)
};

const de_team_create_failed = /** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Erstellen des Teams.`)
};

const id_team_create_failed = /** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal membuat tim.`)
};

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const ja_team_create_failed = en_team_create_failed;

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const zh_team_create_failed = en_team_create_failed;

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const ar_team_create_failed = en_team_create_failed;

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const it_team_create_failed = en_team_create_failed;

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const ru_team_create_failed = en_team_create_failed;

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const pt_team_create_failed = en_team_create_failed;

/** @type {(inputs: Team_Create_FailedInputs) => LocalizedString} */
const ko_team_create_failed = en_team_create_failed;

/**
* | output |
* | --- |
* | "Failed to create team." |
*
* @param {Team_Create_FailedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_create_failed = /** @type {((inputs?: Team_Create_FailedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Create_FailedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_create_failed(inputs)
	if (locale === "es") return es_team_create_failed(inputs)
	if (locale === "fr") return fr_team_create_failed(inputs)
	if (locale === "de") return de_team_create_failed(inputs)
	if (locale === "ja") return ja_team_create_failed(inputs)
	if (locale === "zh") return zh_team_create_failed(inputs)
	if (locale === "ar") return ar_team_create_failed(inputs)
	if (locale === "id") return id_team_create_failed(inputs)
	if (locale === "it") return it_team_create_failed(inputs)
	if (locale === "ru") return ru_team_create_failed(inputs)
	if (locale === "pt") return pt_team_create_failed(inputs)
	return ko_team_create_failed(inputs)
});